import { createSelector } from '@reduxjs/toolkit';

import { type CATEGORIES_REDUCER_KEY, categoriesSelectors } from 'app-components/flux/categories';
// import { type FEATURE_FLAGS_REDUCER_KEY, featureFlagsSelectors } from 'app-components/flux/feature-flags';
import type { ScheduledTransaction } from 'app-components/flux/scheduled-transactions/scheduledTransactionsTypes';
import { transactionsUtils } from 'app-components/flux/transactions';
import type RootState from 'app-components/utils/redux-store/rootState';

type State = Pick<
  RootState,
  typeof CATEGORIES_REDUCER_KEY
  // | typeof FEATURE_FLAGS_REDUCER_KEY
>;

export const showConnectOption = createSelector(
  (state: State, model?: ScheduledTransaction) => model,
  categoriesSelectors.getIncomeCOAIds,
  (model, incomeCOAs) => {
    if (model?.billPresentmentAccountId === '0') {
      return false;
    }
    const txn = model?.transaction;
    if (!txn) return false;
    if (model.billPresentmentAccountId) return false;
    if (txn.amount < 0) return true;
    if (txn.coa) {
      return !incomeCOAs.has(txn.coa.id);
    }
    if (transactionsUtils.isSplitTxn(txn)) {
      return !!(
        txn.split?.items && Boolean(txn.split.items.find((item: any) => item?.coa?.id && !incomeCOAs.has(item.coa.id)))
      );
    }
    return false;
  },
);

//   const creditAccount = useAppSelector((state) => transactionsSelectors.getCreditAccountFromTxn(state, transaction));
//   const canBVA = Boolean(bvaEnabled && creditAccount && transactionsUtils.isTransferTxn(transaction));

// export const showBillTab = createSelector(
//     [
//         (_state, model?: ScheduledTransaction) => model,
//         categoriesSelectors.getIncomeCOAIds,
//         (state: State) => featureFlagsSelectors.getFeatureFlag(state, 'billsFiserv'),
//     ],
//     (model, incomeCOAs, fiServ) => {
//         if (fiServ) {
//             // here
//         }
//   );
